const contentstack = require("contentstack");

// Fetched once from the server's /config/:key endpoint and cached. The server
// hydrates these from AWS SSM at boot, so they aren't baked into the JS bundle.
let stackPromise;

export const getContentstack = () => {
  if (stackPromise) return stackPromise;

  stackPromise = (async () => {
    const [apiKeyRes, deliveryTokenRes] = await Promise.all([
      fetch('/config/CS_API_KEY').then(r => r.json()),
      fetch('/config/CS_DELIVERY_TOKEN').then(r => r.json()),
    ]);
    return contentstack.Stack(
      apiKeyRes.value,
      deliveryTokenRes.value,
      process.env.REACT_APP_LOGIN_ENV === "prod"
        ? "prod"
        : process.env.REACT_APP_LOGIN_ENV === "psup"
          ? "psup"
          : "uat"
    );
  })();

  return stackPromise;
};
